import { detectWindow } from "@/utils/useScreen";

const getIsMobile = () => {
  if (process.server) {
    const headers = useRequestHeaders(["user-agent"]);
    const userAgent = headers["user-agent"] || "";
    return /mobi|android|iphone/i.test(userAgent);
  }
  return detectWindow("device") === "mobile";
};

export const useDeviceDetection = () => {
  return {
    getIsMobile,
  };
};
